module.exports = __webpack_public_path__ + "static/img/trrafic-back-test.c55c0e9c.png";